// extracted by mini-css-extract-plugin
module.exports = {"UserMenu":"_1oVM2","ActivatorWrapper":"_2smDR","Activator":"_2uJPe","Details":"_2rgrY","Name":"nWhd0","Detail":"uonhE","ActionListContainer":"_36ign"};